import { type SchedulerPro, type SchedulerProConfig } from '@bryntum/schedulerpro'

// That event handler is called when the scheduler is resized to allow the group headers to be re-rendered with the correct width.
export const onResize: SchedulerProConfig['onResize'] = ({ source }) => {
  ;(source as SchedulerPro).renderContents()
}
